import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, CardGroup, Col, Form, Row, Modal, Table } from 'react-bootstrap';
import Spinner from '../../shared/spinner';
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import { format, parseISO } from 'date-fns';
import { PropostaObservacao } from '../../shared/model/propostaObservacao';
import { PropostaEsteira } from '../../shared/model/propostaEsteira';
import { ProcessoEsteiraDTO } from '../../shared/dto/processoEsteiraDTO';
import { PropostaDTO } from '../../shared/dto/propostaDTO';
import { IntegracaoExternaPaginadaDTO } from '../../shared/dto/integracaoExternaPaginadaDTO';
import { formatIntegration, FormattedIntegration } from '../../utils/formatters/integracaoExternaFormatter';
import IntegracaoExternaGridRow from '../../components/integracaoExterna/IntegracaoExternaGridRow';
import IntegracaoExternaDetail from '../../components/integracaoExterna/IntegracaoExternaDetail';
import { AcaoPropostaEnum } from '../../shared/constantes/acaoPropostaEnum';
import { TipoDocumento } from '../../shared/constantes/tipoDocumento';
import { ArquivoDTO } from '../../shared/dto/arquivoDTO';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faUser, faPrint, faEye } from '@fortawesome/free-solid-svg-icons';
import { getLabelSituacaoEsteiraEnum } from '../../shared/constantes/situacaoEsteiraEnum';
import ReprovarOuPendenciarPropostaModal from '../../shared/reprovarOuPendenciarPropostaModal';
import PropostaService from '../../services/propostaService';
import PropostaDocumentoService from '../../services/propostaDocumentoService';
import EsteiraService from '../../services/esteiraService';
import PropostaEsteiraService from '../../services/propostaEsteiraService';
import PropostaObservacaoService from '../../services/propostaObservacaoService';
import CustomAlert from '../../shared/customAlert';
import { getLabelTipoProp } from '../../shared/constantes/tiposProposta';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import { PropostaRefin } from '../../shared/model/propostaRefin';
import ParametrosService from '../../services/parametrosService';
import MenuService from "../../services/menuService";
import BigDataService from '../../services/bigDataService';
import { CalculoResultadoSimulacaoDTO } from '../../shared/dto/calculoResultadoSimulacaoDTO';
import { BiDollar } from 'react-icons/bi';
import { Financiamento } from '../../shared/model/financiamento';
import FinanciamentoService from '../../services/financiamentoService';
import { ResultadoSimulacaoPropostaDTO } from '../../shared/dto/resultadoSimulacaoPropostaDTO';
import { Role } from '../../shared/model/role';
import UsuarioService from '../../services/usuarioService';
import { TiposContaBanco } from '../../shared/constantes/tiposContaBanco';
import { Link } from 'react-router-dom';
import { ProtectedActionInterno } from '../../AccessControl';
import { PropostaCompraDivida } from '../../shared/model/propostaCompraDivida';
import BancoService from '../../services/bancoService';
import ComprovanteAverbacaoService from '../../services/comprovanteAverbacaoService';
import { Banco } from '../../shared/model/banco';
import { TipoPagamentoEnum } from '../../shared/constantes/tipoPagamentoEnum';

function PropostaEsteiraComponent() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  const [temPermissaoDossie, setTemPermissaoDossie] = useState(false); //Dossiê
  const [acoesAlcada, setAcoesAlcada] = useState({
    aprova: false,
    reprova: false,
    pendencia: false,
    altera: false
  });

  const navigate = useNavigate();
  const location = useLocation();
  const { idProposta, esteira, processoEsteira } = location.state || {};

  const [numeroProposta, setNumeroProposta] = useState('');

  const [backoffice, setBackoffice] = useState<string>('');

  const [showHistoricoModal, setShowHistoricoModal] = useState(false);
  const [historicoPropostas, setHistoricoPropostas] = useState<any[]>([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);

  const [showIntegracoesModal, setShowIntegracoesModal] = useState(false);
  const [integracoes, setIntegracoes] = useState<Array<FormattedIntegration & { id: number }>>([]);
  const [paginaAtualIntegracoes, setPaginaAtualIntegracoes] = useState(0);
  const [tamanhoPaginaIntegracoes, setTamanhoPaginaIntegracoes] = useState(10);
  const [totalPaginasIntegracoes, setTotalPaginasIntegracoes] = useState(0);
  const [registroSelecionado, setRegistroSelecionado] = useState<FormattedIntegration | null>(null);
  const [carregandoIntegracoes, setCarregandoIntegracoes] = useState(false);

  const [loading, setLoading] = useState(false);
  const [propostaObservacao, setPropostaObservacao] = useState<PropostaObservacao[]>([]);
  const [propostaEsteira, setPropostaEsteira] = useState<PropostaEsteira[]>([]);
  const [propostaRefin, setPropostaRefin] = useState<PropostaRefin[]>([]);
  const [propostaCompraDivida, setPropostaCompraDivida] = useState<PropostaCompraDivida[]>([]);
  const [proposta, setProposta] = useState<PropostaDTO>();
  const [checkObsBanco, setCheckObsBanco] = useState(false);
  const [obs, setObs] = useState('');
  const [processoEsteiraDTO, setProcessoEsteiraDTO] = useState<ProcessoEsteiraDTO>();
  const tipoDocumento = TipoDocumento;
  const [tipoDocumentoSelecionado, setTipoDocumentoSelecionado] = useState(0);
  const [arquivo, setArquivo] = useState<File | null>(null);
  const [arquivoBase64, setArquivoBase64] = useState<string>('');
  const [nomeArquivo, setNomeArquivo] = useState<string>('');
  const [arquivosDTO, setArquivosDTO] = useState<ArquivoDTO[]>([]);

  const [showModal, setShowModal] = useState(false);
  const [currentAction, setCurrentAction] = useState<AcaoPropostaEnum | null>(null);
  const [tipoPendenciaRecusa, setTipoPendenciaRecusa] = useState<string>('R');
  const [dossieData, setDossieData] = useState<any>(null);
  const [valoresSimulacao, setValoresSimulacao] = useState<CalculoResultadoSimulacaoDTO>();
  const [valorParcela, setValorParcela] = useState('0');
  const [prazos, setPrazos] = useState([]);
  const [prazo, setPrazo] = useState('');
  const [tpProduto, setTpProduto] = useState('');
  const [idFinanciamentoEscolhido, setIdFinanciamentoEscolhido] = useState('');
  const [tabelaFinanciamentos, setTabelaFinanciamentos] = useState<Financiamento>();
  const [showResultadoSimulacao, setShowResultadoSimulacao] = useState(false);
  const [resultadoSimulacaoFinal, setResultadoSimulacaoFinal] = useState<ResultadoSimulacaoPropostaDTO>();
  const [dtPrimeiroVencimento, setDtPrimeiroVencimento] = useState('');
  const [dtUltimoVencimento, setDtUltimoVencimento] = useState('');
  const [isUsuarioInterno, setIsUsuarioInterno] = useState(false);
  const [role, setRole] = useState<Role | null>(null);
  const [valorRMC, setValorRMC] = useState<string>('');
  const [tipoConta, setTipoConta] = useState('');
  const [banco, setBanco] = useState('');
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [dv, setDv] = useState('');
  const [shouldScroll, setShouldScroll] = useState(false);
  const [bancos, setBancos] = useState<Banco[]>([]);

  const propostaService: PropostaService = new PropostaService();
  const propostaDocumentoService: PropostaDocumentoService = new PropostaDocumentoService();
  const propostaEsteiraService: PropostaEsteiraService = new PropostaEsteiraService();
  const esteiraService: EsteiraService = new EsteiraService();
  const propostaObservacaoService: PropostaObservacaoService = new PropostaObservacaoService();
  const menuService = new MenuService();
  const bigDataService = new BigDataService();
  const financiamentoService: FinanciamentoService = new FinanciamentoService();
  const usuarioService = new UsuarioService();
  const bancoService: BancoService = new BancoService();
  const [comprovantesData, setComprovantesData] = useState<any>(null);

  const tiposConta = TiposContaBanco;

  useEffect(() => {
    let ativo = true;

    const realizarLockImediato = async () => {
      try {
        await propostaService.lockProposta(idProposta);
      } catch (error: any) {
        if (ativo) {
          setAlert({
            message: "Esta proposta acabou de ser bloqueada por outro usuário ou sua sessão expirou.",
            type: 'error'
          });
          navigate('/esteira-proposta/FLUXO');
        }
      }
    };

    realizarLockImediato();

    const intervalId = setInterval(async () => {
      try {
        await propostaService.heartbeatProposta(idProposta);
      } catch (error: any) {
        clearInterval(intervalId);
        
        setAlert({
          message: "Sua sessão de edição expirou por inatividade ou perda de conexão. A proposta foi liberada.",
          type: 'warning'
        });
        
        navigate('/esteira-proposta/FLUXO');
      }
    }, 30000);

    const handleTabClose = (event: BeforeUnloadEvent) => {
      propostaService.unlockPropostaKeepAlive(idProposta);
    };
    
    window.addEventListener('beforeunload', handleTabClose);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('beforeunload', handleTabClose);
      propostaService.unlockProposta(idProposta).catch(console.error);
    };
  }, [idProposta, navigate]);

  const formatDateOnly = (date?: Date | string | null) => {
  if (!date) return '';

  if (typeof date === 'string') {
    const dateOnly = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnly) {
      return `${dateOnly[3]}/${dateOnly[2]}/${dateOnly[1]}`;
    }

    return format(parseISO(date), 'dd/MM/yyyy');
  }

  return format(date, 'dd/MM/yyyy');
};

  const buscarComprovantes = async (numeroAde: string) => {
    try {
      const service = new ComprovanteAverbacaoService();
      // Usando o endpoint de ADE que você criou no service!
      const dados = await service.buscarPorAde(numeroAde);

      setComprovantesData(dados);
    } catch (error) {
      console.error("Erro ao buscar dados do comprovante por ADE:", error);
      setComprovantesData(null);
    }
  };

  const handleBaixarComprovante = async (numeroAde: string) => {
    if (!numeroAde) {
      setAlert({ message: 'Número ADE não encontrado para este comprovante.', type: 'error' });
      return;
    }

    try {
      const service = new ComprovanteAverbacaoService();
      const pdfBlob = await service.baixarComprovantePdf(numeroAde);

      // Lógica para forçar o navegador a fazer o download do Blob
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      // Define o nome do arquivo que será baixado
      link.setAttribute('download', `comprovante_averbacao_${numeroAde}.pdf`);
      document.body.appendChild(link);
      link.click();

      // Limpa a memória do navegador
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Erro ao baixar o comprovante", error);
      setAlert({ message: 'Não foi possível baixar o comprovante de averbação.', type: 'error' });
    }
  };

  const handleExibirHistorico = async () => {
    setShowHistoricoModal(true);

    // Verifica se existe um CPF para consultar
    if (!proposta?.cpfCliente) return;

    setLoadingHistorico(true);
    try {
      const response = await propostaService.listarPropostasAnterioresPorCpf(proposta.cpfCliente, proposta.id);
      setHistoricoPropostas(response.data);
    } catch (err: any) {
      console.error("Erro ao buscar histórico:", err);
      setAlert({ message: 'Erro ao buscar o histórico de propostas do cliente.', type: 'error' });
    } finally {
      setLoadingHistorico(false);
    }
  };

  const abrirModalIntegracoes = () => {
    setShowIntegracoesModal(true);
    setRegistroSelecionado(null);
    setPaginaAtualIntegracoes(0);
    setTamanhoPaginaIntegracoes(10);
    buscarIntegracoesExternas(0, 10);
  };

  const fecharModalIntegracoes = () => {
    setShowIntegracoesModal(false);
    setRegistroSelecionado(null);
    setIntegracoes([]);
    setPaginaAtualIntegracoes(0);
    setTotalPaginasIntegracoes(0);
  };

  const buscarIntegracoesExternas = async (page: number, size: number) => {
    if (!idProposta) return;
    setCarregandoIntegracoes(true);
    try {
      const response = await propostaService.listarIntegracoesExternasPorProposta(parseInt(idProposta), page, size);
      const paginacao: IntegracaoExternaPaginadaDTO = response.data;
      setIntegracoes(paginacao.content.map(item => ({ ...formatIntegration(item), id: item.id })));
      setTotalPaginasIntegracoes(paginacao.totalPages);
      setPaginaAtualIntegracoes(paginacao.number);
      setTamanhoPaginaIntegracoes(paginacao.size);
    } catch (err: any) {
      console.error("Erro ao buscar integrações externas:", err);
      setAlert({ message: 'Erro ao buscar as integrações externas da proposta.', type: 'error' });
    } finally {
      setCarregandoIntegracoes(false);
    }
  };

  const verificarPermissaoDossie = async () => {
    try {
      const rotaDossie = '/bigData/consultar';
      const response = await menuService.verificaPermissaoPaginaPorRole(rotaDossie);
      setTemPermissaoDossie(response.data);
    } catch (error) {
      console.error("Erro ao verificar permissão do Dossiê:", error);
      setTemPermissaoDossie(false);
    }
  };

  const listarTodosBancos = async () => {
    try {
      setLoading(true);
      const responseList = await bancoService.listarTodosBancos();
      setBancos(responseList.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const carregarAcoesAlcada = async () => {
    try {
      const response = await propostaEsteiraService.permissoesAcoesAlcada();
      setAcoesAlcada(response.data);
    } catch (error) {
      console.error("Erro ao carregar permissões de alçada:", error);
    }
  };

  const fetchDossieData = async () => {
    try {
      const response = await bigDataService.consultarDossie(idProposta);
      setDossieData(response.data);
    } catch (error) {
      console.error("Erro ao buscar dados do Dossiê:", error);
      setDossieData(null);
    }
  };
  const parametrosService: ParametrosService = new ParametrosService();

  const listarUsuarioPorId = async () => {
    setLoading(true);
    try {
      const id = localStorage.getItem("id") ?? "";
      const response = await usuarioService.listarUsuarioComOrigemPorId(id);
      const json = response.data[0].usuario;

      setRole(json.role);

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response?.data || 'Erro ao carregar usuário', type: 'error' });
      console.error(err);
    }
  };

  const gerarRelatorioProposta = async (idProposta: number) => {
    setLoadingHistorico(true);

    try {
      const resp = await propostaService.listarPropostaEspelhoJasper(idProposta);

      const blob = new Blob([resp.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url);

    } catch (err) {
      console.error('Erro ao gerar relatório:', err);
    } finally {
      setLoadingHistorico(false);
    }
  };


  const handleModalCancel = () => {
    setShowModal(false);
  };

  const handleModalConfirm = (motivoSelect: string) => {
    if (currentAction) {
      acaoProposta(currentAction, motivoSelect);
    }
    setShowModal(false);
  };

  const listarTodosParametrosTi = async () => {
    const responseList = await parametrosService.listarTodosParametros();
    const json = responseList.data;

    console.log(json)
    console.log(json.backoffice)


    setBackoffice(json.backoffice)
    console.log(backoffice)
  }

  const normalize = (str: any) => {
    if (!str) return "";
    return String(str).normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toUpperCase();
  };

  const ultimaAtividadeRegistrada = propostaEsteira.length > 0
    ? propostaEsteira[propostaEsteira.length - 1].atividade
    : '';

  console.log("ultimaAtividadeRegistrada: ", ultimaAtividadeRegistrada)

  const isInterno = role?.tipoAcesso === 'INTERNO';

  const atividadeLimpa = normalize(ultimaAtividadeRegistrada);

  console.log("atividadeLimpa: ", atividadeLimpa)

  const isFaseAnexar = atividadeLimpa.includes('ANEX') && atividadeLimpa.includes('DOCUMENT');

  const podeAcaoRestrita = isInterno;

  console.log("isFaseAnexar: ", isFaseAnexar)

  console.log("isInterno: ", isInterno)

  console.log("acao restrita: ", podeAcaoRestrita)



  useEffect(() => {
    listarUsuarioPorId();
    const run = async () => {
      const numero = await listarEsteiraProcesso();
      await listarDocumentosProposta(numero);
      await carregarAcoesAlcada();
      await listarTodosBancos();
    };
    run();
    verificarPermissaoDossie();
  }, []);


  useEffect(() => {
    if (proposta?.adeAverbacao) {
      buscarComprovantes(proposta.adeAverbacao);
    }
  }, [proposta?.adeAverbacao]);


  const listarEsteiraProcesso = async () => {
    setLoading(true);
    try {
      console.log("processoEsteira: ", processoEsteira);
      const response = await esteiraService.listarEsteiraProcessoPorIdProposta(idProposta);
      const jsonResponse = response.data;
      console.log(response.data)
      setProcessoEsteiraDTO(jsonResponse);
      setProposta(jsonResponse.propostaDTO);
      setPropostaEsteira(jsonResponse.esteiraDTO.propostaEsteiraList);
      setPropostaObservacao(jsonResponse.esteiraDTO.propostaObservacaoList);
      setPropostaRefin(jsonResponse.propostaRefinList);
      setPropostaCompraDivida(jsonResponse.propostaCompraDividaList);
      console.log(jsonResponse.propostaDTO.numeroProposta)
      setNumeroProposta(jsonResponse.propostaDTO.numeroProposta || '');
      setLoading(false);
      setTpProduto(jsonResponse.propostaDTO.tpProduto!);
      return jsonResponse.propostaDTO.numeroProposta
    } catch (err: any) {
      if (err.response?.status === 409) {
        console.error("Conflito: Proposta já em análise. Redirecionando para /sem-permissao", err.response.data);

        navigate('/sem-permissao', { state: { message: err.response.data } });

      } else {
        console.error("Erro ao carregar cliente:", err);
        setAlert({ message: err.response?.data || 'Erro ao carregar dados do cliente.', type: 'error' });
        setLoading(false);
      }
    }
  };

  const handleClickObs = async () => {
    setLoading(true);
    let propostaObs = new PropostaObservacao();
    propostaObs.obsBanco = checkObsBanco ? 1 : 0;
    propostaObs.observacao = obs;
    propostaObs.proposta = Number(idProposta);

    try {
      const response = await propostaObservacaoService.inclusaoPropostaObservacao(propostaObs);
      const jsonResponse = response.data;

      setPropostaObservacao([...propostaObservacao, jsonResponse]);
      setObs('');
      setCheckObsBanco(false);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Erro ao salvar observação:", err);
      setAlert({ message: 'Erro ao salvar comentário.', type: 'error' });
    }
  }

  const acaoProposta = async (acaoPropostaEnum: AcaoPropostaEnum, idMotivo: string | null) => {
    setLoading(true);
    try {
      const response = await propostaEsteiraService.incluirPropostaEsteira(idProposta, acaoPropostaEnum, idMotivo);
      const jsonResponse = response.data;

      setLoading(false);
      setAlert({ message: 'Ação ' + acaoPropostaEnum + ' realizada com sucesso!', type: 'success' });

      await sleep(2000);

      window.history.back()
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: 'Ação ' + acaoPropostaEnum + '! Erro ao realizar a ação.\n' + err.response.data, type: 'error' });
      console.error(err);
    }
  }

  const handleGerarRelatorioBigData = async (
    idProposta: number,
    tipoPdf: number,
    idBureau: number
  ) => {
    setLoading(true);
    try {
      const response = await bigDataService.geraRelatorioPdf(idProposta.toString(),
        tipoPdf, idBureau);

      // Cria um blob com o PDF recebido
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      // Abre o PDF em uma nova aba
      window.open(url);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Erro ao gerar relatório:", error);
      setAlert({
        message: 'Erro ao gerar relatório de comparação de dados',
        type: 'error'
      });
    }
  };

  const handleClickUpload = (event: any) => {
    setArquivo(event.target.files[0]);
    const reader = new FileReader();
    reader.onload = (e) => {
      if (typeof e.target?.result === 'string') {
        setArquivoBase64(e.target.result);
      }
    };
    reader.readAsDataURL(event.target.files[0]);
    setNomeArquivo(event.target.files[0].name);
  }

  const { REACT_APP_PERFIL } = process.env;

  const uploadArquivo = async () => {
    if (tipoDocumentoSelecionado === 0) {
      setAlert({ message: 'Selecione o tipo de documento!', type: 'warning' });
    } else {
      if (arquivo) {
        setLoading(true);
        try {
          let arquivoDTO = new ArquivoDTO();
          arquivoDTO.arquivoBase64 = arquivoBase64.split(',')[1];
          arquivoDTO.idProposta = Number(idProposta);
          arquivoDTO.nomeArquivo = nomeArquivo;

          if (REACT_APP_PERFIL == 'QISTA') {
            arquivoDTO.caminhoArquivo = "azure://" + nomeArquivo
          }
          arquivoDTO.tipoDocumento = tipoDocumentoSelecionado;

          await propostaDocumentoService.inclusaoPropostaDocumento(arquivoDTO)
            .then((resp) => {
              setArquivosDTO([...arquivosDTO, resp.data]);
              setTipoDocumentoSelecionado(0);
              setNomeArquivo('')
              setLoading(false);
              setAlert({ message: 'Arquivo incluído com sucesso!', type: 'success' });
            });
        } catch (err) {
          console.error(err);
          setLoading(false);
        }
      }
    }
  }

  const listarDocumentosProposta = async (numero: string) => {
    setLoading(true);
    try {

      const responseList = await parametrosService.listarTodosParametros();
      const json = responseList.data;
      setBackoffice(json.backoffice);
      let idAux = idProposta;
      if (json.backoffice === 'FUNCAO' && numero != null && numero.length > 0) {
        idAux = numero;
      }
      const response = await propostaDocumentoService.listarPropostaDocumentoPorIdProposta(idAux);
      setArquivosDTO(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const downloadArquivo = async (caminhoArquivo: string, nomeArquivo: string) => {
    setLoading(true);
    try {
      const resp = await propostaDocumentoService.downloadPropostaDocumentoPorCaminhoArquivo(caminhoArquivo);

      if (!resp || !resp.data) {
        throw new Error('Arquivo não encontrado.');
      }

      const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
      const urlBlob = window.URL.createObjectURL(blob);
      const linkDownload = document.createElement('a');
      linkDownload.href = urlBlob;
      linkDownload.download = nomeArquivo;
      document.body.appendChild(linkDownload);
      linkDownload.click();
      document.body.removeChild(linkDownload);
      window.URL.revokeObjectURL(urlBlob);
    } catch (err: any) {
      console.error(err);
      if (err.response?.status === 404 && caminhoArquivo.startsWith('s3://'))
        setAlert({ message: 'Documento não encontrado no S3!', type: 'error' });
      else
        setAlert({ message: err.response?.data || 'Erro ao baixar o arquivo!', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const downloadBase64 = (base64String: string, fileName: string): void => {
    // Remove o prefixo se ele existir para converter corretamente
    const base64Data = base64String.split(',')[1] || base64String;

    // Converte Base64 para um array de bytes
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Cria o Blob e a URL temporária
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    // Limpeza
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url); // Importante para memória!
  };


  const downloadTodosArquivos = async () => {
    setLoading(true);
    try {
      await propostaDocumentoService.downloadLotePropostaDocumentoPorIdProposta(idProposta)
        .then((resp) => {
          const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
          const urlBlob = window.URL.createObjectURL(blob);
          const linkDownload = document.createElement('a');
          linkDownload.href = urlBlob;
          linkDownload.download = "Proposta_" + (numeroProposta || proposta?.numeroProposta || 'sem_numero') + '.zip';
          document.body.appendChild(linkDownload);
          linkDownload.click();
          document.body.removeChild(linkDownload);
          window.URL.revokeObjectURL(urlBlob);
          setLoading(false);
        });
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  // Dispara a busca do histórico automaticamente quando a proposta (e o CPF) terminarem de carregar
  useEffect(() => {
    if (proposta?.cpfCliente) {
      handleExibirHistorico();
    }
  }, [proposta?.cpfCliente]);

  const excluirArquivo = async (caminhoArquivo: string, index: number) => {
    setLoading(true);
    try {
      await propostaDocumentoService.excluirPropostaDocumentoPorCaminhoArquivo(caminhoArquivo)
        .then(() => {
          const newTabelaIdade = [...arquivosDTO];
          newTabelaIdade.splice(index, 1);
          setArquivosDTO(newTabelaIdade);
        });
      setLoading(false);
      setAlert({ message: 'Arquivo excluído com sucesso!', type: 'success' });
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  // useEffect(() => {
  //   listarEsteiraProcesso();
  //   listarDocumentosProposta();
  // }, []);

  useEffect(() => {
    const run = async () => {
      try {
        const respDossie = await menuService.verificaPermissaoPaginaPorRole('/bigData/consultar');
        setIsUsuarioInterno(respDossie.data === true);
      } catch (e) {
        setIsUsuarioInterno(false);
      }

      const numero = await listarEsteiraProcesso();
      await listarDocumentosProposta(numero);
      await carregarAcoesAlcada();
    };

    run();
    verificarPermissaoDossie();
  }, []);

  useEffect(() => {
    if (temPermissaoDossie) {
      fetchDossieData();
    }
  }, [temPermissaoDossie, idProposta]);

  const carregouFinanciamento = useRef(false);

  type PropostaModo =
    | 'VISUALIZAR_PROP'
    | 'ANALISE_RMC'
    | 'ANEXAR_DOCS'
    | 'RES_PEND';

  const modo: PropostaModo = (() => {
    switch (processoEsteira) {
      case 'ANALISE_RMC':
        return 'ANALISE_RMC';
      case 'ANEXAR_DOCS':
        return 'ANEXAR_DOCS';
      case 'RES_PEND':
        return 'RES_PEND';
      case 'VISUALIZAR_PROP':
        return 'VISUALIZAR_PROP';
      default:
        return 'VISUALIZAR_PROP';
    }
  })();

  const simulacaoEnabled =
    modo === 'ANALISE_RMC' || modo === 'RES_PEND';

  const isEmprestimo =
    tpProduto === 'EMPRESTIMO' ||
    tpProduto === 'ANTECIPACAO_REMUNERACAO';

  useEffect(() => {
    if (!proposta?.codigoTabela || carregouFinanciamento.current) return;

    carregouFinanciamento.current = true;
    listarFinanciamentoDTOPorId(proposta.codigoTabela.trim());
  }, [proposta?.codigoTabela]);

  useEffect(() => {
    if (
      modo === 'ANALISE_RMC' || modo === 'RES_PEND'
    ) {
      const codigoTabela = proposta?.codigoTabela;
      const valorRmc = proposta?.valorRMCUtilizado;
      if (
        codigoTabela &&
        valorRmc
      ) {
        setIdFinanciamentoEscolhido(codigoTabela);
        setValorRMC(valorRmc.toFixed(2).replace('.', ','));
        simulacaoRMCTotal(codigoTabela, false);
      }
    }
  }, [
    modo,
    proposta?.codigoTabela,
    tabelaFinanciamentos
  ]);

  useEffect(() => {
    if (shouldScroll) {
      simulacaoRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      setShouldScroll(false);
    }
  }, [shouldScroll]);

  useEffect(() => {
    if (proposta && modo === 'RES_PEND') {
      setTipoConta(proposta.tipoConta ?? '');
      setBanco(proposta.banco ?? '');
      setAgencia(proposta.agencia ?? '');
      setConta(proposta.conta ?? '');
      setDv(proposta.contaDv ?? '');
    }
  }, [proposta, modo]);

  const extrairCodigo = (valor?: string) => {
    if (!valor) return undefined;
    return valor.split('-')[0].trim();
  };

  const limparCodigoTabela = (codigo?: string) => {
    if (!codigo) return undefined;
    return codigo.replace(/\s/g, '');
  };

  const formatarValorMonetario = (valor: any) => {
    if (!valor) return '0,00';
    const valorComCentavos = valor.padStart(3, '0');
    const reais = valorComCentavos.slice(0, -2);
    const centavos = valorComCentavos.slice(-2);
    return `${parseInt(reais, 10)},${centavos}`;
  };

  const handleValorParcela = (e: string) => {
    const valorDigitado = e.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorParcela(valorFormatado);
  };

  const handleValorRMC = (e: string) => {
    const valorDigitado = e.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorRMC(valorFormatado);
  };

  const listarFinanciamentoDTOPorId = async (codigoTabela: string) => {
    setLoading(true);
    try {
      const response = await financiamentoService.listarPorId(codigoTabela);
      const jsonFinanciamento = response.data;
      setTabelaFinanciamentos(jsonFinanciamento);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const simulacaoRMCTotal = async (codigoFinanciamento: string, isScroll: boolean) => {
    try {
      setLoading(true);
      let calculoResultadoSimulacaoDTO: CalculoResultadoSimulacaoDTO = new CalculoResultadoSimulacaoDTO();
      const valormc = (valorRMC && valorRMC.length > 0)
        ? parseFloat(valorRMC.replace(',', '.'))
        : parseFloat(proposta?.valorRMCUtilizado?.toString() || "0");

      calculoResultadoSimulacaoDTO.valoresRMCRefin = null;
      calculoResultadoSimulacaoDTO.promotora = extrairCodigo(proposta?.promotora)!;
      calculoResultadoSimulacaoDTO.empregador = extrairCodigo(proposta?.empregador)!;
      calculoResultadoSimulacaoDTO.financiamento = limparCodigoTabela(codigoFinanciamento)!;
      calculoResultadoSimulacaoDTO.produto = extrairCodigo(proposta?.produto)!;
      calculoResultadoSimulacaoDTO.valorRMC = valormc;
      calculoResultadoSimulacaoDTO.valorLimite = 0;
      calculoResultadoSimulacaoDTO.limiteCompra = 0;
      calculoResultadoSimulacaoDTO.limiteSaque = 0;
      calculoResultadoSimulacaoDTO.tarifaEmissao = 0;
      calculoResultadoSimulacaoDTO.anuidade = 0;
      calculoResultadoSimulacaoDTO.dtNascimentoCliente = new Date(`${proposta!.dtNascimentoCliente}T00:00:00.000Z`);

      console.log(calculoResultadoSimulacaoDTO);
      await propostaService.simulacaoRMCTotal(calculoResultadoSimulacaoDTO)
        .then(resp => {
          const jsonList = resp.data;

          setValoresSimulacao(jsonList);
          const parc = proposta?.valorParcela!.toFixed(2).replace('.', ',');
          handleValorParcela(parc!);
          setPrazos(jsonList.prazos);
          setPrazo(jsonList.prazos[0]);
          setLoading(false);

          if (isScroll) {
            setShouldScroll(true);
          }

        })
    } catch (err: any) {
      setLoading(false);
      console.error(err);
      setAlert({ message: err.response.data, type: 'error' });
    }
  }

  const resultadoSimulacaoParcela = async (e: any) => {
    if (parseFloat(valorParcela.replace(',', '.')) > parseFloat(valoresSimulacao?.limiteSaque.toFixed(2)!) && !isEmprestimo) {
      setAlert({ message: 'Informe valor da parcela menor ou igual ao limite de saque', type: 'warning' });
    } else if (parseFloat(valorParcela.replace(',', '.')) > parseFloat(valoresSimulacao?.valorRMC.toFixed(2)!) && isEmprestimo) {
      setAlert({ message: 'Informe valor da parcela menor ou igual ao limite de saque', type: 'warning' });
    }
    let simulacaoPropostaDTO: ResultadoSimulacaoPropostaDTO = new ResultadoSimulacaoPropostaDTO();
    simulacaoPropostaDTO.promotora = extrairCodigo(proposta?.promotora)!;
    simulacaoPropostaDTO.pontoVenda = extrairCodigo(proposta?.pontoVenda)!;
    simulacaoPropostaDTO.empregador = extrairCodigo(proposta?.empregador)!;
    simulacaoPropostaDTO.financiamento = idFinanciamentoEscolhido;
    simulacaoPropostaDTO.produto = extrairCodigo(proposta?.produto)!;
    simulacaoPropostaDTO.tipoProposta = extrairCodigo(proposta?.tipoProposta)!;
    simulacaoPropostaDTO.valorRMC = proposta?.valorRMCUtilizado!;
    simulacaoPropostaDTO.valorParcela = parseFloat(valorParcela.replace(',', '.'));
    simulacaoPropostaDTO.valorSolicitado = 0;
    simulacaoPropostaDTO.prazo = parseInt(prazo);

    simulacaoPropostaDTO.limiteSaque = valoresSimulacao?.limiteSaque!;

    simulacaoPropostaDTO.cpfCliente = proposta?.cpfCliente!;
    simulacaoPropostaDTO.nomeCliente = proposta?.nomeCliente!;
    simulacaoPropostaDTO.matriculaCliente = proposta?.matriculaCliente!;
    simulacaoPropostaDTO.dtNascimentoCliente = proposta?.dtNascimentoCliente!;
    simulacaoPropostaDTO.orgao = extrairCodigo(proposta?.orgao)!;
    simulacaoPropostaDTO.valorIof = 0;
    simulacaoPropostaDTO.valorPrincipal = 0;
    simulacaoPropostaDTO.valorRefin = 0;
    simulacaoPropostaDTO.valorCompra = 0;
    simulacaoPropostaDTO.valorLiquido = 0;
    simulacaoPropostaDTO.valorBruto = 0;
    simulacaoPropostaDTO.taxaClAM = 0;
    simulacaoPropostaDTO.taxaClAA = 0;
    simulacaoPropostaDTO.taxaCetAM = 0;
    simulacaoPropostaDTO.taxaCetAA = 0;
    simulacaoPropostaDTO.primeiroVencimento = new Date();
    simulacaoPropostaDTO.ultimoVencimento = new Date();

    try {
      setLoading(true);
      console.log(simulacaoPropostaDTO);
      await propostaService.resultadoSimulacaoParcela(simulacaoPropostaDTO)
        .then(resp => {
          const jsonList = resp.data;
          console.log(resp.data)

          setResultadoSimulacaoFinal(jsonList);
          setDtPrimeiroVencimento(format(parseISO(jsonList.primeiroVencimento), 'dd/MM/yyyy'));
          setDtUltimoVencimento(format(parseISO(jsonList.ultimoVencimento), 'dd/MM/yyyy'));
          setShowResultadoSimulacao(true);
          setLoading(false);
          setShouldScroll(true);
        })
    } catch (err: any) {
      setLoading(false);
      console.error(err);
      setAlert({ message: err.response.data, type: 'error' });
      setShowResultadoSimulacao(false);

    }
  }

  const atualizarProposta = async () => {
    try {
      setLoading(true);

      if (!resultadoSimulacaoFinal || !proposta) {
        setAlert({ message: 'Simulação inválida', type: 'error' });
        return;
      }

      const propostaAtualizada: PropostaDTO = {
        ...proposta,

        promotora: extrairCodigo(proposta?.promotora)!,
        pontoVenda: extrairCodigo(proposta?.pontoVenda)!,
        produto: extrairCodigo(proposta?.produto)!,
        tipoProposta: extrairCodigo(proposta?.tipoProposta)!,
        empregador: extrairCodigo(proposta?.empregador)!,
        orgao: extrairCodigo(proposta?.orgao)!,

        valorRMCUtilizado: valoresSimulacao?.valorRMC!,
        valorLimite: valoresSimulacao?.valorLimite!,
        limiteCompra: valoresSimulacao?.limiteCompra!,
        limiteSaque: valoresSimulacao?.limiteSaque!,
        tarifaEmissao: valoresSimulacao?.tarifaEmissao!,
        anuidade: valoresSimulacao?.anuidade!,
        simulacaoProposta: resultadoSimulacaoFinal!
      };

      await propostaService.atualizarProposta(propostaAtualizada);

      setAlert({
        message: 'Proposta atualizada com sucesso',
        type: 'success'
      });

    } catch (err: any) {
      console.error(err);
      setAlert({
        message: err?.response?.data || 'Erro ao atualizar proposta',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const atualizarDadosBancarios = async () => {
    try {
      setLoading(true);

      if (!proposta) {
        setAlert({ message: 'Proposta inválida', type: 'error' });
        return;
      }

      const dadosBancariosAtualizados: PropostaDTO = {
        ...proposta,

        banco: banco!,
        agencia: agencia!,
        conta: conta!,
        contaDv: dv!,
        tipoConta: tipoConta!
      };

      await propostaService.atualizarDadosBancarios(dadosBancariosAtualizados);

      setAlert({
        message: 'Dados bancários atualizados com sucesso',
        type: 'success'
      });

    } catch (err: any) {
      console.error(err);
      setAlert({
        message: err?.response?.data || 'Erro ao atualizar dados bancários',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const simulacaoRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="position-relative m-md-3">
      <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
        {esteira === 'S' ? <h5>Esteira &gt; Proposta  - {numeroProposta || proposta?.numeroProposta || '-'} &gt; Processos</h5> : <h5>Esteira &gt; Proposta  - {numeroProposta || proposta?.numeroProposta || '-'} &gt; Detalhes</h5>}
        <Button id="App-button-cor-principal" onClick={() => window.history.back()}> Voltar</Button>
      </div>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      {loading ? <Spinner loading={loading} /> : (
        <>
          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>Origem</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Promotora</span>
                    <input type="text" value={proposta?.promotora!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Supervisor</span>
                    <input type="text" value={proposta?.gerente!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Operador</span>
                    <input type="text" value={proposta?.operador!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Ponto de Venda</span>
                    <input type="text" value={proposta?.pontoVenda!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Empregador</span>
                    <input type="text" value={proposta?.empregador!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Secretaria/UPAG</span>
                    <input type="text" value={proposta?.orgao!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>Cliente</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>CPF Cliente</span>
                    <input type="text" value={proposta?.cpfCliente!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Nome</span>
                    <input type="text" value={proposta?.nomeCliente!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Matricula</span>
                    <input type="text" value={proposta?.matriculaCliente!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Data de Nascimento</span>
                    <input type="text"
                      value={proposta?.dtNascimentoCliente ? format(parseISO(proposta?.dtNascimentoCliente.toString()), 'dd/MM/yyyy') : ''}
                      className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>$ Proposta - <span>{proposta?.numeroProposta ?? '-'}</span></strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Tipo de Proposta</span>
                    <input type="text" value={getLabelTipoProp(proposta?.tipoProposta!)} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor RMC Online</span>
                    <input type="text" value={proposta?.valorMargemOnline ? proposta.valorMargemOnline.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 'Não consultado'} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor RMC Utilizado</span>
                    <input type="text"
                      value={(proposta?.valorRMCUtilizado ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Limite Cartão</span>
                    <input type="text"
                      value={(proposta?.valorLimite ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Limite Compra</span>
                    <input type="text"
                      value={(proposta?.limiteCompra ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Limite Saque</span>
                    <input type="text"
                      value={(proposta?.limiteSaque ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Despesas</span>
                    <input type="text" value="0,00" className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor TC</span>

                    <input type="text" value="0,00" className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Anuidade</span>

                    <input type="text" value={proposta?.anuidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa CL a.m.</span>

                    <input type="text" value={proposta?.taxaClAm.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa CL a.a.</span>
                    <input type="text" value={proposta?.taxaClAa.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa CET a.m.</span>
                    <input
                      type="text"
                      value={proposta?.taxaCetAm.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      className="form-control form-control-sm brds"
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa CET a.a.</span>
                    <input
                      type="text"
                      value={proposta?.taxaCetAa.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      className="form-control form-control-sm brds"
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {propostaRefin && propostaRefin!.length > 0 && (
            <div className="card" style={{ marginTop: '25px' }}>
              <div className="card-header">
                <strong>$ Contratos Refinanciados</strong>
              </div>
              <div className="card-body">
                {propostaRefin!.map((item) => (
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Número Contrato</span>
                        <input type="text" value={item?.contratoLiquidado!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-1">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Saldo</span>
                        <input type="text" value={item?.saldo!.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Valor da Parcela</span>
                        <input type="text" value={item?.valorParcela!.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-1">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Prazo Total</span>
                        <input type="text" value={item?.prazo!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Parcelas em Aberto</span>
                        <input type="text" value={(item?.prazo! - item?.parcelasLiquidadas!)} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Parcelas Vencidas</span>
                        <input type="text" value={item?.parcelasVencidas!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Parcelas a Vencer</span>
                        <input type="text" value={item?.parcelasAVencer!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {propostaCompraDivida && propostaCompraDivida!.length > 0 && (
            <div className="card" style={{ marginTop: '25px' }}>
              <div className="card-header">
                <strong>$ Contratos Comprados</strong>
              </div>
              <div className="card-body">
                {propostaCompraDivida!.map((item) => (
                  <div className="row">
                    <div className="col-md-2">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Banco/Entidade</span>
                        <input type="text" value={bancos.find((banco) => banco.id === item?.idBanco!)?.nome} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Número Contrato</span>
                        <input type="text" value={item?.numeroContrato!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-1">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Saldo</span>
                        <input type="text" value={item?.saldoDevedor!.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-1">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }} className="text-nowrap">Dt. Vencimento</span>
                        <input type="text" value={formatDateOnly(item?.dataVencimento)} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Valor da Parcela</span>
                        <input type="text" value={item?.valorParcela!.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    {/* <div className="col-md-1">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }} className="text-nowrap">Prazo Total</span>
                        <input type="text" value={item?.prazo!} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Parcelas Pagas</span>
                        <input type="text" value={(item?.parcelasPagas!)} className="form-control form-control-sm brds " style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }} />
                      </div>
                    </div> */}
                    <div className="col-md-1">
                      <div
                        className="form-group mb-0"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-end',
                          height: '100%'
                        }}
                      >

                        <Button
                          className="btn btn-sm"
                          onClick={() => downloadBase64(item?.arquivo!, item?.nomeArquivo!)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '31px',
                            padding: '0.25rem 0.5rem',
                            margin: '0'
                          }}
                        >
                          <FontAwesomeIcon icon={faDownload} />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>$ Saque Parcelado</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Solicitado</span>
                    <input
                      type="text"
                      value={proposta?.valorSolicitado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor IOF</span>
                    <input
                      type="text"
                      value={proposta?.valorIof.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Tarifa de Cadastro</span>
                    <input
                      type="text"
                      value="0,00"
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Seguro</span>
                    <input
                      type="text"
                      value="0,00"
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Maximo de Compra</span>
                    <input
                      type="text"
                      value={(proposta?.valorMaximoCompra ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds "
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Financiado</span>
                    <input
                      type="text"
                      value={proposta?.valorPrincipal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Líquido</span>
                    <input
                      type="text"
                      value={proposta?.valorLiquido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                {propostaCompraDivida && propostaCompraDivida!.length > 0 && (
                  <div className="col-md-2">
                    <div className="form-group">
                      <span style={{ textAlign: 'left' }}>Saldo Devedor</span>
                      <input
                        type="text"
                        /* Somamos todos os valores líquidos do array */
                        value={propostaCompraDivida
                          .reduce((acc, curr) => acc + (curr.saldoDevedor || 0), 0)
                          .toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        }
                        className="form-control form-control-sm brds"
                        readOnly
                        style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                      />
                    </div>
                  </div>)}

              </div>
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Prazo</span>
                    <input
                      type="text"
                      value={proposta?.prazo}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Parcela</span>
                    <input
                      type="text"
                      value={proposta?.valorParcela.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Bruto</span>
                    <input
                      type="text"
                      value={proposta?.valorBruto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Primeiro Vencimento</span>
                    <input
                      type="text"
                      value={proposta?.dtPrimeiroVencimento ? formatDateOnly(proposta?.dtPrimeiroVencimento) : ''}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Último Vencimento</span>
                    <input
                      type="text"
                      value={proposta?.dtUltimoVencimento ? formatDateOnly(proposta?.dtUltimoVencimento) : ''}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Tabela</span>
                    <input
                      type="text"
                      value={proposta?.codigoTabela}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Nome Tabela</span>
                    <input
                      type="text"
                      value={proposta?.tabela}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'left' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa CL a.m.</span>
                    <input
                      type="text"
                      value={(proposta?.taxaClSaqueAm ?? proposta?.taxaClAm ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa CET a.m.</span>
                    <input
                      type="text"
                      value={proposta?.taxaCetAm.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa AP a.m.</span>
                    <input
                      type="text"
                      value={(proposta?.taxaApAm ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa Nominal a.m.</span>
                    <input
                      type="text"
                      value="0,0"
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa CL a.a.</span>
                    <input
                      type="text"
                      value={(proposta?.taxaClSaqueAa ?? proposta?.taxaClAa ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa CET a.a.</span>
                    <input
                      type="text"
                      value={proposta?.taxaCetAa.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa AP a.a.</span>
                    <input
                      type="text"
                      value={(proposta?.taxaApAa ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Taxa Nominal a.a.</span>
                    <input
                      type="text"
                      value="0,0"
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>$ Dados de liberação</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Valor Saque</span>
                    <input
                      type="text"
                      value={proposta?.valorLiquido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      className="form-control form-control-sm brds"
                      readOnly
                      style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Tipo de Conta</span>
                    {modo === 'RES_PEND' ? (
                      <select
                        className="form-select form-select-sm brds"
                        value={tipoConta}
                        onChange={(e) => setTipoConta(e.target.value)}
                        required
                        id="Campo-obrigatorio"
                      >
                        <option value="">Selecione</option>
                        {tiposConta.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type="text"
                        value={proposta?.tipoConta}
                        className="form-control form-control-sm brds"
                        readOnly
                        style={{ backgroundColor: 'LightGrey' }}
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Banco</span>
                    <input
                      type="text"
                      value={modo === 'RES_PEND' ? banco : proposta?.banco}
                      onChange={(e) => setBanco(e.target.value)}
                      className="form-control form-control-sm brds"
                      readOnly={modo !== 'RES_PEND'}
                      required={modo === 'RES_PEND'}
                      id={modo === 'RES_PEND' ? 'Campo-obrigatorio' : undefined}
                      style={{ backgroundColor: modo === 'RES_PEND' ? '#fff' : 'LightGrey' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Agência</span>
                    <input
                      type="text"
                      value={modo === 'RES_PEND' ? agencia : proposta?.agencia}
                      onChange={(e) => setAgencia(e.target.value)}
                      className="form-control form-control-sm brds"
                      readOnly={modo !== 'RES_PEND'}
                      required={modo === 'RES_PEND'}
                      id={modo === 'RES_PEND' ? 'Campo-obrigatorio' : undefined}
                      style={{ backgroundColor: modo === 'RES_PEND' ? '#fff' : 'LightGrey' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Conta</span>
                    <input
                      type="text"
                      value={modo === 'RES_PEND' ? conta : proposta?.conta}
                      onChange={(e) => setConta(e.target.value)}
                      className="form-control form-control-sm brds"
                      readOnly={modo !== 'RES_PEND'}
                      required={modo === 'RES_PEND'}
                      id={modo === 'RES_PEND' ? 'Campo-obrigatorio' : undefined}
                      style={{ backgroundColor: modo === 'RES_PEND' ? '#fff' : 'LightGrey' }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>DV</span>
                    <input
                      type="text"
                      value={modo === 'RES_PEND' ? dv : proposta?.contaDv}
                      onChange={(e) => setDv(e.target.value)}
                      className="form-control form-control-sm brds"
                      readOnly={modo !== 'RES_PEND'}
                      required={modo === 'RES_PEND'}
                      id={modo === 'RES_PEND' ? 'Campo-obrigatorio' : undefined}
                      style={{ backgroundColor: modo === 'RES_PEND' ? '#fff' : 'LightGrey' }}
                    />
                  </div>
                </div>
              </div>
              {modo === 'RES_PEND' && (
                <div className="row mt-3">
                  <div className="col-md-12 text-end">
                    <button className="btn btn-success btn-sm" onClick={() => atualizarDadosBancarios()}>
                      Atualizar Dados Bancários
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="card-body">
              {propostaCompraDivida?.map((item, index) => (
                <div className="row">
                  <div className="col-md-2">
                    <div className="form-group">
                      <span style={{ textAlign: 'left' }}>Valor Saldo Devedor</span>
                      <input
                        type="text"
                        value={item.saldoDevedor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        className="form-control form-control-sm brds"
                        readOnly
                        style={{ color: 'Black', backgroundColor: 'LightGrey', textAlign: 'right' }}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <span style={{ textAlign: 'left' }}>Tipo de Pagamento</span>
                      <input
                        type="text"
                        value={TipoPagamentoEnum.find(t => t.value === item.tipoPagamento.toString())?.label}
                        className="form-control form-control-sm brds"
                        readOnly
                        style={{ backgroundColor: 'LightGrey' }}
                      />
                    </div>
                  </div>
                  {item.tipoPagamento === 1 && (
                    <div className="col-md-5">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Linha Digitável</span>
                        <input
                          type="text"
                          value={item.informacaoPagamento}
                          className="form-control form-control-sm brds"
                          readOnly
                          style={{ backgroundColor: 'LightGrey' }}
                        />
                      </div>
                    </div>
                  )}
                  {item.tipoPagamento === 2 && (
                    <div className="col-md-5">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>QR Code PIX</span>
                        <input
                          type="text"
                          value={item.informacaoPagamento}
                          className="form-control form-control-sm brds"
                          readOnly
                          style={{ backgroundColor: 'LightGrey' }}
                        />
                      </div>
                    </div>
                  )}
                  {item.tipoPagamento === 3 && (
                    <div className="col-md-5">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Chave Aleatória PIX</span>
                        <input
                          type="text"
                          value={item.informacaoPagamento}
                          className="form-control form-control-sm brds"
                          readOnly
                          style={{ backgroundColor: 'LightGrey' }}
                        />
                      </div>
                    </div>
                  )}
                  {item.tipoPagamento === 4 && (
                    <>
                      <div className="col-md-2">
                        <div className="form-group">
                          <span style={{ textAlign: 'left' }}>Tipo de Conta</span>
                          <input
                            type="text"
                            value={item.tipoConta}
                            className="form-control form-control-sm brds"
                            readOnly
                            style={{ backgroundColor: 'LightGrey' }}
                          />
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div className="form-group">
                          <span style={{ textAlign: 'left' }}>Banco</span>
                          <input
                            type="text"
                            value={item.codigoBanco}
                            className="form-control form-control-sm brds"
                            readOnly
                            style={{ backgroundColor: 'LightGrey' }}
                          />
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div className="form-group">
                          <span style={{ textAlign: 'left' }}>Agência</span>
                          <input
                            type="text"
                            value={item.agencia}
                            className="form-control form-control-sm brds"
                            readOnly
                            style={{ backgroundColor: 'LightGrey' }}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <span style={{ textAlign: 'left' }}>Conta</span>
                          <input
                            type="text"
                            value={item.conta}
                            className="form-control form-control-sm brds"
                            readOnly
                            style={{ backgroundColor: 'LightGrey' }}
                          />
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div className="form-group">
                          <span style={{ textAlign: 'left' }}>DV Conta</span>
                          <input
                            type="text"
                            value={item.dvConta}
                            className="form-control form-control-sm brds"
                            readOnly
                            style={{ backgroundColor: 'LightGrey' }}
                          />
                        </div>
                      </div>
                    </>
                  )}

                </div>))}
            </div>
          </div>

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>$ Informações Adicionais</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12">
                  <div className="info">
                    <label>Nº do Contrato:</label>
                    <span> {proposta?.numeroContrato}</span>
                  </div>
                  {/* <div className="info">
                    <label>Nº do Cartão:</label>
                    <span></span>
                  </div> */}
                  <div className="info">
                    <label>Nº Formalização:</label>
                    <span> {proposta?.idFormalizacao}</span>
                  </div>
                  {/* <div className="info">
                    <label>ID Externo Proposta:</label>
                    <span></span>
                  </div> */}
                  <div className="info">
                    <label>Nº Contrato Consignado:</label>
                    <span> {proposta?.numeroContratoExterno}</span>
                  </div>
                  <div className="info">
                    <label>ADE:</label>
                    <span> {proposta?.adeAverbacao}</span>
                  </div>
                  {/* <div className="info">
                    <label>URL CCB Não Assinada:</label>
                    <span></span>
                  </div>
                  <div className="info">
                    <label>URL CCB Assinada:</label>
                    <span></span>
                  </div> */}
                  <div className="info">
                    <label>ID Tabela:</label>
                    <span> {proposta?.codigoTabela}</span>
                  </div>
                  <div className="info">
                    <label>Código Esteira:</label>
                    <span> {proposta?.idEsteira}</span>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {simulacaoEnabled && valoresSimulacao && (
            <div className="card" style={{ marginTop: '25px' }}>
              <div id='simulacao' ref={simulacaoRef} className="card-header">
                <strong>Valores Aprovados</strong>
              </div>
              <div className="card-body">
                {/* VALOR RMC */}
                <div className="row align-items-end">
                  <div className="col-md-3">
                    <div className="form-group">
                      <span>Valor RMC</span>
                      <input
                        type="text"
                        value={valorRMC}
                        onChange={(e) => handleValorRMC(e.target.value)}
                        className="form-control form-control-sm brds"
                        style={{ backgroundColor: '#fff9c4' }}
                      // disabled={modo === 'RES_PEND'}
                      />
                    </div>
                  </div>

                  {/* BOTÃO REPROCESSAR */}
                  {modo === 'ANALISE_RMC' || modo === 'RES_PEND' && (
                    <div className="col-md-3">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => simulacaoRMCTotal(valoresSimulacao.financiamento, true)}
                      >
                        <i className="fa fa-calculator" /> Recalcular RMC
                      </button>
                    </div>
                  )}
                </div>

                <div className="card-header">
                  <b>Resultado Simulação - {proposta?.codigoTabela} - {proposta?.tabela}</b>
                </div>
                <div className="card-body">
                  <div style={{ backgroundColor: 'white', padding: 'auto' }}>
                    <div className="input-card">
                      <Form.Label>{isEmprestimo ? 'Valor Margem' : 'Valor do Limite'}</Form.Label>
                      <div className="card-text">
                        R$ {valoresSimulacao?.valorRMC.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </div>
                    </div>
                  </div>
                  <CardGroup>
                    {/* CARTÃO: Proposta de Limite */}
                    {!isEmprestimo && (
                      <Card style={{ borderRadius: '0px 0px 0px 15px' }}>
                        <Card.Body>
                          <Card.Title>Proposta de Limite</Card.Title>

                          <div className="card-field">Valor RMC</div>
                          <div className="card-text">
                            R$ {valoresSimulacao?.valorRMC.toLocaleString('pt-BR')}
                          </div>

                          <div className="card-field">Limite Total</div>
                          <div className="card-text">
                            R$ {valoresSimulacao?.valorLimite.toLocaleString('pt-BR')}
                          </div>

                          <div className="card-field">Limite de Compras</div>
                          <div className="card-text">
                            R$ {valoresSimulacao?.limiteCompra.toLocaleString('pt-BR')}
                          </div>

                          <div className="card-field">Limite Saque</div>
                          <div className="card-text">
                            R$ {(proposta?.tipoProposta === 'CARTAO_SEM_SAQUE'
                              ? 0
                              : valoresSimulacao?.limiteSaque || 0
                            ).toLocaleString('pt-BR')}
                          </div>
                        </Card.Body>
                      </Card>
                    )}

                    {/* EMPRESTIMO: Valores de contrato */}
                    {isEmprestimo && (
                      <Card>
                        <Card.Body>
                          <Card.Title>Condições do Empréstimo</Card.Title>

                          <div className="card-field">Valor Mínimo Contratado</div>
                          <div className="card-text">
                            R$ {valoresSimulacao?.valorMinContratado?.toLocaleString('pt-BR')}
                          </div>

                          <div className="card-field">Valor Máximo Contratado</div>
                          <div className="card-text">
                            R$ {valoresSimulacao?.valorMaximoContratado?.toLocaleString('pt-BR')}
                          </div>

                          <div className="card-field">Valor Mínimo da Parcela</div>
                          <div className="card-text">
                            R$ {valoresSimulacao?.valorMinParcela?.toLocaleString('pt-BR')}
                          </div>

                          <div className="card-field">Valor Máximo da Parcela</div>
                          <div className="card-text">
                            R$ {valoresSimulacao?.valorMaxParcela?.toLocaleString('pt-BR')}
                          </div>
                        </Card.Body>
                      </Card>
                    )}

                    {/* Convênio – comum */}
                    <Card>
                      <Card.Body>
                        <Card.Title>Convênio</Card.Title>

                        <div className="card-field">Empregador</div>
                        <div className="card-text">
                          {proposta?.empregador}
                        </div>

                        <div className="card-field">Produto</div>
                        <div className="card-text">
                          {proposta?.produto}
                        </div>

                        <div className="card-field">Tabela</div>
                        <div className="card-text">
                          {proposta?.codigoTabela} - {proposta?.tabela}
                        </div>
                      </Card.Body>
                    </Card>

                    {/* Fatura – somente cartão */}
                    {!isEmprestimo && (
                      <Card style={{ borderRadius: '0px 0px 15px 0px' }}>
                        <Card.Body>
                          <Card.Title>Fatura</Card.Title>

                          <div className="card-field">Dia de Corte</div>
                          <div className="card-text">
                            {tabelaFinanciamentos?.diaCorte}
                          </div>

                          <div className="card-field">Dia de Vencimento</div>
                          <div className="card-text">
                            {tabelaFinanciamentos?.diaVencimento}
                          </div>
                        </Card.Body>
                      </Card>
                    )}
                  </CardGroup>
                  <div className="saque">
                    <Row className="mb-3">
                      <Form.Group as={Col} md="2" controlId="validationName">
                        <Form.Label>Valor Parcela</Form.Label>
                        <input type="text" required className="form-control" value={valorParcela} onChange={(e) => handleValorParcela(e.target.value)} />
                      </Form.Group>

                      <Form.Group as={Col} md='4' controlId="formBasicSelect">
                        <Form.Label>Prazo</Form.Label>
                        <select className="form-select" defaultValue={prazo} value={prazo} onChange={(e) => setPrazo(e.target.value)}
                        >
                          {prazos.map((item) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </select>
                      </Form.Group>

                      <div className="button-area">
                        <Button variant='primary' onClick={resultadoSimulacaoParcela}>
                          <BiDollar /> Simular</Button>
                      </div>
                    </Row>
                  </div>
                  {showResultadoSimulacao && !loading ? (
                    <>
                      <div className="header-cards">
                        <b>Resultado Simulação Saque Parcelado</b>
                      </div><CardGroup>
                        <Card style={{ borderRadius: '0px 0px 0px 15px' }}>
                          <Card.Body>
                            <Card.Title>Valores</Card.Title>
                            <div className="card-field">Valor Solicitado</div>
                            <div className="card-text">R$ {resultadoSimulacaoFinal?.valorSolicitado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                            <div className="card-field">Valor IOF</div>
                            <div className="card-text">R$ {resultadoSimulacaoFinal?.valorIof.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                            <div className="card-field">Valor Líquido</div>
                            <div className="card-text">R$ {resultadoSimulacaoFinal?.valorLiquido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                            <div className="card-field">Valor Parcela</div>
                            <div className="card-text">R$ {resultadoSimulacaoFinal?.valorParcela.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                          </Card.Body>
                        </Card>
                        <Card>
                          <Card.Body>
                            <Card.Title style={{ border: "'black', '1px'" }}>Valores</Card.Title>
                            <div className="card-field">Valor Refin</div>
                            <div className="card-text">R$ {resultadoSimulacaoFinal?.valorRefin.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                            {!isEmprestimo && (
                              <>
                                <div className="card-field">Valor Compra</div>
                                <div className="card-text">R$ {resultadoSimulacaoFinal?.valorCompra.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                              </>
                            )}
                          </Card.Body>
                        </Card>
                        <Card>
                          <Card.Body>
                            <Card.Title>Valores</Card.Title>
                            <div className="card-field">Valor Principal</div>
                            <div className="card-text">R$ {resultadoSimulacaoFinal?.valorPrincipal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                            <div className="card-field">Valor Bruto</div>
                            <div className="card-text">R$ {resultadoSimulacaoFinal?.valorBruto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                          </Card.Body>
                        </Card>
                        <Card style={{ borderRadius: '0px 0px 15px 0px' }}>
                          <Card.Body>
                            <Card.Title>Taxas</Card.Title>
                            <div className="card-field">Taxa CL a.m.</div>
                            <div className="card-text">{resultadoSimulacaoFinal?.taxaClAM.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</div>
                            <div className="card-field">Taxa CL a.a.</div>
                            <div className="card-text">{resultadoSimulacaoFinal?.taxaClAA.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</div>
                            <div className="card-field">Taxa CET a.m.</div>
                            <div className="card-text">{resultadoSimulacaoFinal?.taxaCetAM.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</div>
                            <div className="card-field">Taxa CET a.a.</div>
                            <div className="card-text">{resultadoSimulacaoFinal?.taxaCetAA.toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</div>
                          </Card.Body>
                        </Card>
                        <Card>
                          <Card.Body>
                            <Card.Title>Prazos</Card.Title>
                            <div className="card-field">Prazo</div>
                            <div className="card-text">{resultadoSimulacaoFinal?.prazo}</div>
                            <div className="card-field">Primeiro Vencimento</div>
                            <div className="card-text">{dtPrimeiroVencimento}</div>
                            <div className="card-field">Último Vencimento</div>
                            <div className="card-text">{dtUltimoVencimento}</div>
                          </Card.Body>
                        </Card>
                      </CardGroup>
                      {(parseFloat(resultadoSimulacaoFinal?.valorParcela.toFixed(2)!) <= parseFloat(valoresSimulacao?.limiteSaque.toFixed(2)!) && !isEmprestimo) && (
                        <div className="button-area" style={{ marginTop: '1rem' }}>
                          <Button variant='success' onClick={atualizarProposta}><BiDollar /> Atualizar Proposta</Button>
                        </div>
                      )}
                      {(parseFloat(resultadoSimulacaoFinal?.valorParcela.toFixed(2)!) <= parseFloat(valoresSimulacao?.valorRMC.toFixed(2)!) && isEmprestimo) && (
                        <div className="button-area" style={{ marginTop: '1rem' }}>
                          <Button variant='success' onClick={atualizarProposta}><BiDollar /> Atualizar Proposta</Button>
                        </div>
                      )}
                    </>
                  ) : false}
                </div>
              </div>
            </div>
          )}

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header ">
              <strong>Documentos</strong>
            </div>
            <div className="card-body">
              <div className="row">
                {!proposta?.isFinalizada && (
                  <>
                    <div className="col-md-3">
                      <div className="form-group">
                        <span>Tipo de Documento</span>
                        <span style={{ textAlign: 'left' }}></span>
                        <select
                          className="form-select"
                          onChange={(e) => setTipoDocumentoSelecionado(parseInt(e.target.value))}
                        >
                          <option value="0">Selecione uma opção</option>
                          {tipoDocumento.map((item) => (
                            <option key={item.label} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <span>Arquivo</span>
                        <br />
                        <input id="App-header-table"
                          style={{ color: 'White', width: '90%' }}
                          type="file" className="form-control-file btn btn-info"
                          onChange={(e) => handleClickUpload(e)}
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group" style={{ marginTop: '25px' }}>
                        <a className="btn btn-success">
                          <i className="fa fa-upload"
                            onClick={() => uploadArquivo()}> Importar Arquivo</i>
                        </a>
                      </div>
                    </div>
                  </>
                )}
                {arquivosDTO.length > 0 ? (
                  <div style={{ marginTop: '10px', visibility: 'visible', overflowY: 'auto', width: '100%', borderWidth: '1px' }}>
                    <div>
                      <table cellSpacing="2" cellPadding="4" rules="all" style={{ color: 'Black', backgroundColor: '#CCCCCC', borderColor: '#999999', borderWidth: '3px', borderStyle: 'Solid', width: '100%' }}>
                        <tbody>
                          <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                            <th scope="col" id="App-header-table-esquerda">Nome</th>
                            <th scope="col" id="App-header-table-esquerda">Tipo</th>
                            <th scope="col" id="App-header-table-esquerda">Data e Hora</th>
                            <th align="left" scope="col" id="App-header-table-esquerda">
                              <a onClick={() => downloadTodosArquivos()}>
                                <Button style={{ background: 'black', borderColor: 'black' }}>
                                  <FontAwesomeIcon icon={faDownload} />
                                </Button>
                              </a>
                            </th>
                            <th scope="col" id="App-header-table-esquerda">&nbsp;</th></tr>
                          {arquivosDTO.map((item, index) => (
                            <tr className="GridRowStyle">
                              <td>{item.nomeArquivo}</td>
                              <td>{TipoDocumento.find(tipo => tipo.value === item.tipoDocumento.toString())?.label}</td>
                              <td>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm') : ''}</td>
                              <td align="left">
                                <a onClick={() => downloadArquivo(item.caminhoArquivo, item.nomeArquivo)}>
                                  <Button>
                                    <FontAwesomeIcon icon={faDownload} />
                                  </Button>
                                </a>
                              </td>
                              {isInterno && !proposta?.isFinalizada && (
                                <td align="left">
                                  <a onClick={() => excluirArquivo(item.caminhoArquivo, index)}>
                                    <Button style={{ background: 'red', borderColor: 'red' }}>
                                      <FontAwesomeIcon icon={faClose} />
                                    </Button>
                                  </a>
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (false)}
              </div>
            </div>
          </div>

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header ">
              <strong>Observações</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <span style={{ textAlign: 'left' }}>Observação</span>
                    <div
                      className="form-control form-control-sm brds"
                      style={{
                        color: 'Black',
                        backgroundColor: 'LightGrey',
                        height: '120px',
                        textAlign: 'left',
                        overflowY: 'auto',
                        padding: '5px'
                      }}
                    >
                      {propostaObservacao
                        .filter(item => !isUsuarioInterno ? !item.obsBanco : true)
                        .map((item, index) => (
                          <div key={index}>
                            <span>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm') : ''}</span>
                            <span> - {item.usuario} - </span>
                            <span> {item.observacao} </span>
                            {item.obsBanco && (
                              <span style={{ color: 'red', fontSize: '10px', fontWeight: 'bold', marginLeft: '5px' }}>
                                [INTERNO]
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

              {!proposta?.isFinalizada && (
                <>
                  <div className="row" style={{ marginTop: '15px' }}>
                    <div className="col-md-12">
                      <div className="form-group">
                        <span style={{ textAlign: 'left' }}>Nova Observação</span>
                        <textarea
                          className="form-control"
                          style={{ height: '80px', textAlign: 'left', width: '100%' }}
                          value={obs}
                          onChange={(e) => setObs(e.target.value)}
                        />
                        {isUsuarioInterno && (
                          <div style={{ marginTop: '5px' }}>
                            <input
                              type="checkbox"
                              checked={checkObsBanco}
                              onChange={() => setCheckObsBanco(!checkObsBanco)}
                            />
                            <label style={{ marginLeft: '5px' }}>Observação interna do Banco</label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <a className="btn btn-success" onClick={handleClickObs}>
                        <i className="fa fa-save"> Gravar Observação</i>
                      </a>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header ">
              <strong>Status da Proposta</strong>
            </div>
            <div className="card-body">
              <div style={{ width: '100%', borderWidth: '1px' }}>
                <table cellSpacing="2" cellPadding="4" rules="all" style={{ border: '3', color: 'Black', borderColor: '#999999', borderWidth: '3px', borderStyle: 'Solid', width: '100%' }}>
                  <tbody>
                    <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                      <th scope="col" id="App-header-table-esquerda">Status</th>
                      <th scope="col" id="App-header-table-esquerda">Data</th>
                      <th scope="col" id="App-header-table-esquerda">Usuário</th>
                      <th scope="col" id="App-header-table-esquerda">Nr</th>
                      <th scope="col" id="App-header-table-esquerda">Atividade</th>
                      <th scope="col" id="App-header-table-esquerda">Ação</th>
                      <th scope="col" id="App-header-table-esquerda">Motivo</th>
                    </tr>
                    {propostaEsteira.map((item) => (
                      <tr className="GridRowStyle">
                        <td>{getLabelSituacaoEsteiraEnum(item.situacaoProposta)}</td>
                        <td>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm') : ''}</td>
                        <td>{item.usuario}</td>
                        <td>{item.numeroAtividade}</td>
                        <td>{item.atividade}</td>
                        <td>{item.acao ? item.acao : 'NaoDefinido'}</td>
                        <td>{item.motivoDescricao}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header ">
              <strong>Status da Fomalização Digital</strong>
            </div>
            <div className="card-body">
              <div style={{ width: '100%', borderWidth: '1px' }}>
                <table cellSpacing="2" cellPadding="4" rules="all" style={{ border: '3', color: 'Black', borderColor: '#999999', borderWidth: '3px', borderStyle: 'Solid', width: '100%' }}>
                  <tbody>
                    <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                      <th scope="col" id="App-header-table-esquerda">Data</th>
                      <th scope="col" id="App-header-table-esquerda">Status</th>
                      <th scope="col" id="App-header-table-esquerda">Titulo</th>
                      <th scope="col" id="App-header-table-esquerda">Descrição</th>
                    </tr>
                    {processoEsteiraDTO?.esteiraDTO.atualizacaoDigital.map((item) => (
                      <tr className="GridRowStyle">
                        <td>{item.dtInclusao ? format(new Date(item.dtInclusao), 'dd/MM/yyyy HH:mm') : ''}</td>
                        <td>{item.isSucesso ? 'Sucesso' : 'Falha'}</td>
                        <td>{item.status}</td>
                        <td>{item.descricao}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <ProtectedActionInterno>
            <div className="card" style={{ marginTop: '25px' }}>
              <div className="card-header">
                <strong>Histórico de Propostas Cliente</strong>
              </div>
              <div className="card-body">
                {loadingHistorico ? (
                  <div className="text-center"><Spinner loading={true} /></div>
                ) : (
                  <div style={{ width: '100%', borderWidth: '1px', maxHeight: '60vh', overflowY: 'auto' }}>
                    <table cellSpacing="2" cellPadding="4" rules="all" style={{ border: '3', color: 'Black', borderColor: '#999999', borderWidth: '3px', borderStyle: 'Solid', width: '100%' }}>
                      <tbody>
                        <tr className="GridHeaderStyle" id="App-button-cor-principal">
                          <th scope="col" className="App-header-table-esquerda" style={{ color: 'white' }}>Proposta</th>
                          <th scope="col" className="App-header-table-esquerda" style={{ color: 'white' }}>Data</th>
                          <th scope="col" className="App-header-table-esquerda" style={{ color: 'white' }}>Situação</th>
                          <th scope="col" className="App-header-table-esquerda" style={{ color: 'white' }}>Produto</th>
                          <th scope="col" className="App-header-table-esquerda" style={{ color: 'white' }}>Valor</th>
                          <th scope="col" className="App-header-table-esquerda" style={{ color: 'white' }}>Contrato</th>
                          <th scope="col" className="App-header-table-esquerda" style={{ color: 'white' }}>Ações</th>
                        </tr>
                        {historicoPropostas && historicoPropostas.length > 0 ? (
                          historicoPropostas.map((hist, index) => (
                            <tr className="GridRowStyle" key={index}>
                              <td>{hist.numeroProposta || '-'}</td>
                              <td>{hist.data ? format(parseISO(hist.data), 'dd/MM/yyyy HH:mm') : ''}</td>
                              <td>{hist.status}</td>
                              <td>{hist.produto}</td>
                              <td>R$ {hist.valor ? hist.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00'}</td>
                              <td>{hist.contrato || '-'}</td>

                              <td>
                                <div style={{ display: 'flex' }}>
                                  {/* Botão de Ver Proposta */}
                                  <Link to={`/proposta-esteira-component`} state={{ idProposta: hist.idProposta, esteira: 'N' }}>
                                    {/* Botão de Ver Proposta */}
                                    <Button
                                      className="btn btn-sm"
                                      style={{ background: 'grey', border: 'grey', marginLeft: '5px' }}
                                      title='Proposta'
                                      onClick={() => {
                                        window.scrollTo({ top: 0, behavior: 'smooth' });

                                        setLoading(true);

                                        navigate(`/proposta-esteira-component`, {
                                          state: { idProposta: hist.idProposta, esteira: 'N' }
                                        });
                                        setTimeout(() => {
                                          window.location.reload();
                                        }, 200);
                                      }}
                                    >
                                      <FontAwesomeIcon size="2xs" icon={faEye} />
                                    </Button>
                                  </Link>

                                  {/* Botão de Imprimir Relatório */}
                                  <a onClick={() => gerarRelatorioProposta(hist.idProposta)} style={{ cursor: 'pointer' }}>
                                    <Button className="btn btn-sm" style={{ background: 'grey', border: 'grey', marginLeft: '5px' }} title='Relatório'>
                                      <FontAwesomeIcon size="2xs" icon={faPrint} />
                                    </Button>
                                  </a>
                                </div>
                              </td>

                            </tr>
                          ))
                        ) : (
                          <tr className="GridRowStyle">
                            {/* Ajustado para 7 colunas */}
                            <td colSpan={7} style={{ textAlign: 'center' }}>Nenhuma proposta anterior encontrada.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </ProtectedActionInterno>

          {temPermissaoDossie && dossieData && (
            <div className="card" style={{ marginTop: '25px' }}>
              <div className="card-header">
                <strong>Dossiê - Análise de Dados Cadastrais</strong>
              </div>
              <div className="card-body">
                <div style={{ width: '100%', borderWidth: '1px' }}>
                  <table
                    cellSpacing="2"
                    cellPadding="4"
                    rules="all"
                    style={{
                      border: '3',
                      color: 'Black',
                      borderColor: '#999999',
                      borderWidth: '3px',
                      borderStyle: 'Solid',
                      width: '100%',
                    }}
                  >
                    <thead>
                      <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                        <th scope="col" id="App-header-table-esquerda">ID</th>
                        <th scope="col" id="App-header-table-esquerda">Nº Proposta</th>
                        <th scope="col" id="App-header-table-esquerda">Tipo de Dossiê</th>
                        <th scope="col" id="App-header-table-esquerda">Criado em</th>
                        <th scope="col" id="App-header-table-esquerda">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(Array.isArray(dossieData) ? dossieData : [dossieData]).map((item: any) => (
                        <tr className="GridRowStyle" key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.numeroProposta || numeroProposta || proposta?.numeroProposta || '-'}</td>
                          <td style={{ fontWeight: 'bold' }}>{item.tipoDossieDescricao}</td>
                          <td>{new Date(item.createdAt).toLocaleString()}</td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => handleGerarRelatorioBigData(item.idProposta, item.tipoPdf, item.id)}
                            >
                              Ver
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}


          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header">
              <strong>Comprovantes de Averbação</strong>
            </div>
            <div className="card-body">
              <div style={{ width: '100%', borderWidth: '1px' }}>
                <table
                  cellSpacing="2"
                  cellPadding="4"
                  rules="all"
                  style={{
                    border: '3',
                    color: 'Black',
                    borderColor: '#999999',
                    borderWidth: '3px',
                    borderStyle: 'Solid',
                    width: '100%',
                  }}
                >
                  <thead>
                    <tr className="GridHeaderStyle" id="App-button-cor-principal" style={{ color: 'White' }}>
                      <th scope="col" id="App-header-table-esquerda">ID</th>
                      <th scope="col" id="App-header-table-esquerda">Número ADE</th>
                      <th scope="col" id="App-header-table-esquerda">Cliente</th>
                      <th scope="col" id="App-header-table-esquerda">CPF</th>
                      <th scope="col" id="App-header-table-esquerda">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(Array.isArray(comprovantesData) ? comprovantesData : [comprovantesData]).map((item: any, index: number) => {

                      // PROTEÇÃO PRINCIPAL: Se o item dentro do array for nulo, ignora e não quebra a tela
                      if (!item) return null;

                      // Formatação segura da data (de YYYY-MM-DD para DD/MM/YYYY)
                      const dataFormatada = item?.dataOperacao
                        ? item.dataOperacao.split('-').reverse().join('/')
                        : 'N/A';

                      // Formatação do valor para moeda BRL
                      const valorFormatado = item?.valorPrestacao
                        ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valorPrestacao)
                        : 'N/A';

                      return (
                        <tr className="GridRowStyle" key={item?.id || index}>
                          <td>{item?.id || '-'}</td>
                          <td style={{ fontWeight: 'bold' }}>{item?.numeroAde || 'N/A'}</td>
                          <td>{item?.nome || 'N/A'}</td>
                          <td>{item?.cpf || 'N/A'}</td>
                          <td>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => {
                                if (item?.numeroAde) {
                                  handleBaixarComprovante(item.numeroAde);
                                } else {
                                  setAlert({ message: 'Número ADE não encontrado.', type: 'error' });
                                }
                              }}
                            >
                              Ver
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>


          <div className="card" style={{ marginTop: '25px' }}>
            <div className="card-header ">
              <strong>Ações</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {acoesAlcada.altera && (
                      <a onClick={() => navigate('/esteira-cliente/alteracao', { state: { idCliente: proposta?.idCliente, edicao: 'edicao', idProposta: idProposta, atualizacaoCadastro: 'false' } })}
                        className="btn btn-secondary">
                        <FontAwesomeIcon icon={faUser} style={{ marginRight: '10px' }} />
                        Detalhes do Cliente
                      </a>
                    )}
                    <a onClick={() => gerarRelatorioProposta(parseInt(idProposta!))}>
                      <Button style={{ background: 'grey', border: 'grey', marginLeft: '5px' }} title='Relatório'>
                        <FontAwesomeIcon icon={faPrint} style={{ marginRight: '10px' }} />
                        Proposta
                      </Button>
                    </a>
                    <a onClick={abrirModalIntegracoes}>
                      <Button style={{ background: 'grey', border: 'grey', marginLeft: '5px' }} title='Integrações Externas'>
                        <FontAwesomeIcon icon={faEye} style={{ marginRight: '10px' }} />
                        Integrações Externas
                      </Button>
                    </a>
                    {esteira === 'S' && propostaEsteira[propostaEsteira.length - 1] !== undefined && propostaEsteira[propostaEsteira.length - 1].acao !== AcaoPropostaEnum.FINALIZADA ? (
                      <>
                        {acoesAlcada.aprova && (
                          <a
                            className="btn btn-success">
                            <i className="fa fa-thumbs-up"
                              onClick={() => acaoProposta(AcaoPropostaEnum.APROVAR, null)}>
                              Aprovar
                            </i>
                          </a>
                        )}
                        {acoesAlcada.pendencia && propostaEsteira.length > 2 && propostaEsteira[propostaEsteira.length - 2].acao !== AcaoPropostaEnum.PENDENCIAR && podeAcaoRestrita && (
                          <a
                            className="btn btn-secondary"
                            style={{ backgroundColor: 'YELLOW', color: 'BLACK' }}
                            onClick={() => {
                              setCurrentAction(AcaoPropostaEnum.PENDENCIAR);
                              setTipoPendenciaRecusa("P");
                              setShowModal(true);
                            }}
                          >
                            Pendenciar
                          </a>
                        )}
                        {acoesAlcada.reprova && podeAcaoRestrita && modo !== 'RES_PEND' && (
                          <a
                            className="btn btn-secondary"
                            style={{ backgroundColor: 'RED', color: 'White' }}
                            onClick={() => {
                              setCurrentAction(AcaoPropostaEnum.REPROVAR);
                              setTipoPendenciaRecusa("R");
                              setShowModal(true);
                            }}
                          >
                            Reprovar
                          </a>
                        )}
                        <ReprovarOuPendenciarPropostaModal
                          showModal={showModal}
                          handleModalCancel={handleModalCancel}
                          handleModalConfirm={handleModalConfirm}
                          tipoPendenciaRecusa={tipoPendenciaRecusa}
                        />
                      </>
                    ) : false}
                    <a
                      id="App-button-cor-principal"
                      className="btn btn-secondary"
                      onClick={() => window.history.back()}
                    >
                      <i className="fa fa-backward"> Voltar</i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <Modal show={showIntegracoesModal} onHide={fecharModalIntegracoes} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Integrações Externas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {carregandoIntegracoes ? (
            <div className="text-center"><Spinner loading={true} /></div>
          ) : registroSelecionado ? (
            <IntegracaoExternaDetail
              integration={registroSelecionado}
              onBack={() => setRegistroSelecionado(null)}
            />
          ) : (
            <div>
              {integracoes.length === 0 ? (
                <p className="text-center">Nenhuma integração externa encontrada para esta proposta.</p>
              ) : (
                <>
                  <div className="table-responsive">
                    <Table striped bordered hover size="sm">
                      <thead>
                        <tr>
                          <th>Tipo</th>
                          <th>Data/Hora</th>
                          <th>Resumo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {integracoes.map((item) => (
                          <IntegracaoExternaGridRow
                            key={item.id}
                            integration={item}
                            onClick={() => setRegistroSelecionado(item)}
                          />
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="d-flex align-items-center">
                      <span style={{ marginRight: '10px' }}>Itens por página:</span>
                      <Form.Select
                        value={tamanhoPaginaIntegracoes}
                        onChange={(e) => {
                          const novoTamanho = parseInt(e.target.value);
                          setTamanhoPaginaIntegracoes(novoTamanho);
                          buscarIntegracoesExternas(0, novoTamanho);
                        }}
                        style={{ width: '80px' }}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                      </Form.Select>
                    </div>
                    <ResponsivePagination
                      current={paginaAtualIntegracoes}
                      total={totalPaginasIntegracoes}
                      onPageChange={(page) => buscarIntegracoesExternas(page, tamanhoPaginaIntegracoes)}
                    />
                  </div>
                </>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={fecharModalIntegracoes}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

    </div >
  );
}

export default PropostaEsteiraComponent;
